import errorImages from "common/constants/errorImages";
import Img from "common/components/Image";

import styles from "../../styles/EmptyResults.module.less";

type LayoutProps = { children: React.ReactNode };

const Results = ({ children }: LayoutProps) => {
  return <div className={styles.container}>{children}</div>;
};

const Header = ({ children }: LayoutProps) => {
  return <div className={styles.header}>{children}</div>;
};

const Text = ({ children }: LayoutProps) => {
  return <div className={styles.text}>{children}</div>;
};

const Content = ({ children }: LayoutProps) => {
  return <div className={styles.content}>{children}</div>;
};

const Body = ({ children }: LayoutProps) => {
  return <div className={styles.body}>{children}</div>;
};

type ImageProps = { src?: string; alt: string };

const Image = ({ src = errorImages.EmptyResults, alt }: ImageProps) => {
  return <Img className={styles.image} src={src} alt={alt} />;
};

export default Object.assign(Results, {
  Header,
  Text,
  Content,
  Body,
  Image,
});
